import { useNavigate } from "react-router-dom";
import { customAuthAxios } from "../../utils/customAuthAxios";
// import { switchQrCardImgAppend } from "@/utils/switchQrCardImgAppend";
import { useSuccessToast } from "../toast/useSuccessToast";

export const useEditKuchikomyuSettingByRestaurant = (settingsId?: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();

  const onSubmit = async (data: any) => {
    console.log("onSubmit")
    try {
      const uploadData = new FormData();
      uploadData.append("id", data.id); // ✅ 明示的にIDを追加
      uploadData.append("restaurant", data.restaurant); // ✅ 必須
      uploadData.append("branch_score", data.branch_score);
      uploadData.append("unique_question", data.unique_question ? "true" : "false");
      uploadData.append("g_url", data.g_url);
      uploadData.append("en_url", data.en_url);
      uploadData.append("default_url", data.default_url);
      uploadData.append("default_en_url", data.default_en_url);

      switchQrCardImgAppend(data.qr_card_img, uploadData);
      switchEnQrCardImgAppend(data.en_qr_card_img, uploadData);

      console.log("unique_question 送信直前:", data.unique_question);

      console.log("✅ uploadData entries:");
      Array.from(uploadData.entries()).forEach(([key, value]) => {
        console.log(key, value);
      });

      await customAuthAxios.put(`kuchikomyu/settings/${settingsId}/`, uploadData);
      showToast("編集が完了しました");
      navigate(-1);
    } catch (error: any) {
      console.error("編集に失敗:", error);
    }
  };

  return onSubmit;
};

const switchEnQrCardImgAppend = (value: any, uploadData: FormData) => {
  // デフォルト画像として扱う
  if (value?.isDefault) {
    uploadData.append("en_qr_card_img", "");
    return;
  }

  // 通常の画像アップロード
  if (value instanceof FileList && value.length > 0) {
    uploadData.append("en_qr_card_img", value[0], value[0].name);
  }
};

const switchQrCardImgAppend = (value: any, uploadData: FormData) => {
  if (value?.isDefault) {
    uploadData.append("qr_card_img", ""); // ← Django 側で `None` にするトリガー
    return;
  }

  if (value instanceof FileList && value.length > 0) {
    uploadData.append("qr_card_img", value[0], value[0].name);
  }
};